import { Color } from '@otrio/engine';

export const COLOR_LABELS: Record<Color, string> = {
  red: 'Red',
  green: 'Green',
  purple: 'Purple',
  yellow: 'Yellow',
};
